import {
	generateUtilityClass,
	generateUtilityClasses,
} from '@netx/core-components/Theme/utils';

export const ATTRIBUTE_CLASS_NAME = 'Attribute';
export const ATTRIBUTE_CLASS_SLOTS = ['root', 'leadingControls'] as const;

export type AttributeClassSlot = (typeof ATTRIBUTE_CLASS_SLOTS)[number];

export interface AttributeClasses {
	root: string;
	leadingControls: string;

	limitHeightToContainer: string;
	matchContainerHeight: string;
}

export type AttributeClassKey = keyof AttributeClasses;

export const getAttributeUtilityClass = (slot: string) =>
	generateUtilityClass(ATTRIBUTE_CLASS_NAME, slot);

export const attributeClasses: AttributeClasses = generateUtilityClasses(
	ATTRIBUTE_CLASS_NAME,
	['root', 'leadingControls', 'limitHeightToContainer', 'matchContainerHeight'],
);

export default attributeClasses;
